<div class="cp-generic-modal">
  <ng-container *ngTemplateOutlet="headerTemplate || defaultHeader"></ng-container>

  <div class="cp-generic-modal__main-content">
    <ng-container *ngTemplateOutlet="contentTemplate || projectedContent"></ng-container>
  </div>

  <div *ngIf="showCTA" class="cp-generic-modal__actions">
    <button
      *ngIf="!buttonLinkHref"
      class="button button--primary"
      [ngClass]="confirmEnabled ? 'button--blue' : 'button--disabled'"
      (click)="confirm($event)"
    >
      {{ confirmText }}
    </button>
    <button cpdsButton theme="mm-light" variant="primary" size="large" *ngIf="buttonLinkHref" (click)="navigate()">
      {{ confirmText }}
    </button>
    <button class="button button--blue button--secondary button--no-border" (click)="cancel($event)" *ngIf="cancelText">
      {{ cancelText }}
    </button>
  </div>
</div>

<ng-template #defaultHeader>
  <div class="cp-generic-modal__header" *ngIf="title || subTitle; else projectedHeader">
    <h1 class="cp-generic-modal__title">{{ title }}</h1>
    <h2 class="cp-generic-modal__sub-title">{{ subTitle }}</h2>
    <!-- conditional? -->
  </div>
</ng-template>

<ng-template #projectedHeader><ng-content select="[header]"></ng-content></ng-template>

<ng-template #projectedContent><ng-content></ng-content></ng-template>
